module.exports = {
        srcSet: __webpack_public_path__ + "assets/images/ladder-1-bcce7437d38233ef.png"+" 222w",
        images: [{path: __webpack_public_path__ + "assets/images/ladder-1-bcce7437d38233ef.png",width: 222,height: 464}],
        src: __webpack_public_path__ + "assets/images/ladder-1-bcce7437d38233ef.png",
        toString: function(){return __webpack_public_path__ + "assets/images/ladder-1-bcce7437d38233ef.png"},
        
        width: 222,
        height: 464
      }